import React, { useMemo } from 'react';
import { RiHome6Line } from 'react-icons/ri';
import { v4 as uuidv4 } from 'uuid';

import Mode from './Mode';

import { getModeId } from '@/utils/CommandUtils';

const Panel = ({ data: robots }) => {
  const modeId = useMemo(() => {
    return getModeId(robots[0].model.vehicle, 'RTL');
  }, [robots]);

  return <Mode data={robots} modeId={modeId} desc="Returns to launch point automatically" />;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'RTL';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiHome6Line;
Command.Panel = Panel;

export default Command;
